import { DoorType } from '../../common/door-type';
import { IDoorSelection, DoorSelection } from './door-selection';
import { IDoorHandleSelection, DoorHandleSelection } from './door-handle-selection';
import { InstallationState } from '../../common/installation-state';

export interface IDoorInstallationModel {
    id: string;
    doorType: DoorType;
    configurationIndex: number;
    selectedDoor: IDoorSelection | undefined;
    selectedDoorPrice: number;
    priceChange: number;
    selectedHandle: IDoorHandleSelection | undefined;
    selectHandle: boolean;
    isExcluded: boolean;
    includedInPrice: string[];
    installationState: InstallationState;
}


export class DoorInstallationModel implements IDoorInstallationModel {
    public id: string = '';
    public doorType: DoorType = DoorType.Indeterminate;
    public configurationIndex: number = 0;
    public selectedDoor: IDoorSelection | undefined = undefined;
    public selectedDoorPrice: number = 0;
    public priceChange: number = 0;
    public selectedHandle: IDoorHandleSelection | undefined = undefined;
    public selectHandle: boolean = false;
    public isExcluded: boolean = false;
    public includedInPrice: string[] = [];
    public installationState: InstallationState = InstallationState.Indeterminate;
}


